import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, TextareaWithLabel, TextFieldWithLabel } from 'shared/ui'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useCallingStepsContext } from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import { UseCaseSelect } from 'pages/settings/pages/compliance/ui/UseCaseSelect/UseCaseSelect'
import { PageErrorAlert } from 'pages/settings/pages/compliance/ui/PageErrorAlert/PageErrorAlert'
import styles from './styles.module.scss'

export const CompanyInfo = observer(() => {
  const {
    voiceIntegrityStore,
    stepsStore: { setTotalSteps, stepLoading },
  } = useCallingStepsContext()

  const {
    useCaseAsItems,
    activeUseCase,
    companySize,
    callsPerDay,
    notes,
    isSubmitDisabled,
    errorMessage,
    companySizeError,
    callsPerDayError,
    setUseCase,
    loadUseCases,
    setCompanySize,
    setCallsPerDay,
    setNotes,
    submitVoiceIntegrity,
    checkCompletedVoiceIntegrity,
  } = voiceIntegrityStore

  useEffect(() => {
    loadUseCases()
    setTotalSteps(2)
    checkCompletedVoiceIntegrity()
  }, [])

  return (
    <div className={styles.wrap}>
      <PageDescription>Provide info about your company and calling usage</PageDescription>

      <PageErrorAlert errorMessage={errorMessage} marginTop={20} marginBottom={40} />

      <Box marginTop={5}>
        <UseCaseSelect
          items={useCaseAsItems}
          value={activeUseCase?.value || ''}
          setValue={setUseCase}
        />
        <TextFieldWithLabel
          marginBottom={3}
          marginTop={3}
          errorMessage={companySizeError}
          labelProps={{
            marginBottom: 4,
            questionTooltipProps: {
              label: 'Total number of employees',
            },
            label: {
              text: 'Company size',
            },
          }}
          textFieldProps={{
            value: companySize,
            onChange: setCompanySize,
            InputProps: {
              placeholder: 'e.g. 20',
            },
            className: styles.textField,
          }}
        />
        <TextFieldWithLabel
          marginBottom={3}
          labelProps={{
            marginBottom: 4,
            questionTooltipProps: {
              label: 'Estimated daily call volume ',
            },
            label: {
              text: 'Average calls per day',
            },
          }}
          errorMessage={callsPerDayError}
          textFieldProps={{
            value: callsPerDay,
            onChange: setCallsPerDay,
            InputProps: {
              placeholder: 'e.g. 100',
            },
            className: styles.textField,
          }}
        />

        <TextareaWithLabel
          labelProps={{ label: { text: 'Notes', secondaryText: '(optional)' } }}
          value={notes}
          limit={160}
          errorType='bottomText'
          name='description'
          placeholder='Additional information about your use case'
          onChange={setNotes}
        />

        <NextButton
          text='Submit for review'
          loading={stepLoading}
          disabled={isSubmitDisabled || stepLoading}
          onClick={submitVoiceIntegrity}
        />
      </Box>
    </div>
  )
})
